import { HeadingWithImage } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export interface IAttributes extends React.ComponentProps<typeof HeadingWithImage>, ICTAAttributes {
  title: React.ReactNode
  subtitle?: React.ReactNode
  tagline?: React.ReactNode
  background: 'white' | 'blue'

  imageDesktopId: number
  imageDesktopUrl: string

  imageMobileId: number
  imageMobileUrl: string
  disclaimer: string
  align: 'center' | 'left'
}

const HeadingWithImageBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const desktopImage = attributes.imageDesktopUrl ? <img src={attributes.imageDesktopUrl} alt="" /> : null
  const mobileImage = attributes.imageMobileUrl ? <img src={attributes.imageMobileUrl} alt="" /> : null
  const { callToAction, secondaryCallToAction } = useCTAAttributes(attributes)

  return (
    <HeadingWithImage
      title={attributes.title}
      subtitle={typeof attributes.subtitle === 'string' ? parse(attributes.subtitle) : attributes.subtitle}
      tagline={attributes.tagline}
      images={{ desktop: desktopImage, mobile: mobileImage }}
      background={attributes.background}
      disclaimer={parse(attributes?.disclaimer ?? '')}
      callToAction={callToAction}
      align="center"
      secondaryCallToAction={secondaryCallToAction}
    />
  )
}

export default HeadingWithImageBlock
